import { render, staticRenderFns } from "./CV.vue?vue&type=template&id=a0020520&scoped=true&"
import script from "./CV.vue?vue&type=script&lang=js&"
export * from "./CV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0020520",
  null
  
)

export default component.exports